module.exports = __webpack_public_path__ + "media/customizations/collective/back-3a4b7dfe33313770bddfe8192eb6550c.jpg";